<div class="timer" dir="ltr">
  <span>{{ minutes()?.toLocaleString("en-US", { minimumIntegerDigits: 2 }) }}</span>
  <span> : </span>
  <span>{{ seconds()?.toLocaleString("en-US", { minimumIntegerDigits: 2 }) }}</span>
</div>
